/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Production {

    import fld = QualityInspectionValuesRow.Fields;

    @Serenity.Decorators.registerClass()
    export class QualityInspectionValuesEditor extends _Ext.GridEditorBase<QualityInspectionValuesRow> {



        protected getColumnsKey() { return "Production.QualityInspectionValues"; }
        protected getDialogType() { return QualityInspectionValuesDialog; }
        protected getLocalTextPrefix() { return QualityInspectionValuesRow.localTextPrefix; }
        protected form: QualityInspectionValuesForm;

        private pendingChanges: Q.Dictionary<any> = {};


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
        }
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();
            var value = ctx => ColumnFormatter.stringInputFormatter(ctx, this);

            var InspectedValue = Q.first(columns, x => x.field === fld.InspectedValue);
            InspectedValue.format =  value;
            var Remark = Q.first(columns, x => x.field === fld.Remark);
            Remark.format = value;

            return columns;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var id = this.id(item);
            var target = $(e.target);

            if (target.hasClass('check-box no-float readonly') || target.hasClass('check-box no-float readonly checked'))
                target.removeClass('readonly')

            if (target.hasClass('check-box no-float')) {
                if (item.Status == true) {
                    item.Status = false;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                }
                else {
                    item.Status = true;
                    this.view.updateItem(id, item);
                    this.view.refresh();

                }
            }
             
        }

        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id]; 

            var effective = this.getEffectiveValue(item, field);
            var oldText: string;
            if (input.hasClass("numeric"))
                oldText = Q.formatNumber(effective, '0.##');
            else
                oldText = effective as string;

            var value;
            if (field === 'ExpectedValue') {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass("numeric")) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else
                value = text;

            // *** Set Department ***
            if (field === fld.Status) {
                item[field] = value;
            } else if (field === fld.Remark) {
                item[field] = value;
            } else if (field === fld.InspectedValue) {
                item[field] = value;
            }

            this.view.updateItem(id, item);
            this.view.refresh(); 

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }
        setData(items: any[]) {
            for (var i = 0; i < items.length; i++) {
                var qc = items[i];
                var newqc: QualityInspectionValuesRow = {
                    Max: qc.Max,
                    Min: qc.Min,
                    ExpectedValue: qc.Value==undefined?qc.ExpectedValue:qc.Value,
                    Parameter: qc.Parameter,
                    InspectedValue: qc.InspectedValue,
                    Status: qc.Status,
                    Remark:qc.Remark
                }
                newqc[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(newqc);
            }
        }

    }
}